import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const ExcludedFilesLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./excluded-files'),
});
